export enum SubscriptionCodeType {
  FREE = 'grafana-cloud-free',
  FREE_TRIAL = 'grafana-cloud-free-trial',
  PRO = 'grafana-cloud-pro',
  ADVANCED = 'grafana-cloud-advanced',
  SS_ADVANCED = 'grafana-cloud-ss-advanced',
}
